import React, { useState } from 'react';
import SettingsSidebar from '../components/settings/SettingsSidebar';
import ProfileTab from '../components/settings/ProfileTab';
import NotificationsTab from '../components/settings/NotificationsTab';
import SecurityTab from '../components/settings/SecurityTab';
import ApiTab from '../components/settings/ApiTab';
import { useSettingsData } from '../hooks/useSettingsData';

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState('profile');
  
  const {
    profileData,
    setProfileData,
    notifications,
    setNotifications,
    security,
    setSecurity,
    saving,
    handleProfileSave,
    handleNotificationsSave,
    handleSecuritySave,
  } = useSettingsData();

  const renderTabContent = () => {
    switch (activeTab) {
      case 'profile':
        return (
          <ProfileTab
            profileData={profileData}
            setProfileData={setProfileData}
            onSave={handleProfileSave}
            saving={saving}
          />
        );
      case 'notifications':
        return (
          <NotificationsTab
            notifications={notifications}
            setNotifications={setNotifications}
            onSave={handleNotificationsSave}
            saving={saving}
          />
        );
      case 'security':
        return (
          <SecurityTab
            security={security}
            setSecurity={setSecurity}
            onSave={handleSecuritySave}
            saving={saving}
          />
        );
      case 'api':
        return <ApiTab />;
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">Settings</h1>
        <p className="mt-2 text-slate-600 dark:text-slate-400">
          Manage your account preferences and security settings
        </p>
      </div>

      {/* Settings Content */}
      <div className="bg-white dark:bg-slate-800 shadow-sm rounded-lg overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-4 min-h-[600px]">
          <SettingsSidebar activeTab={activeTab} setActiveTab={setActiveTab} />
          
          {/* Content */}
          <div className="lg:col-span-3 p-4 lg:p-6 overflow-y-auto">
            <div className="max-w-4xl mx-auto">{renderTabContent()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
